/* src/app/pages/impressum/impressum.page.scss */
ion-content {
  --background: #0d1117;
}
h1 {
  font-size: 30px;
  line-height: 116%;
  letter-spacing: 0.02em;
  vertical-align: middle;
  text-transform: uppercase;
  font-family: AppFontBold;
  text-align: center;
  color: #fff;
  margin-bottom: 20px;
}
h2,
h3,
h4,
h5 {
  font-size: 20px;
  line-height: 116%;
  letter-spacing: 0.02em;
  vertical-align: middle;
  text-transform: uppercase;
  margin-top: 20px;
  margin-bottom: 10px;
  color: #fff;
}
@media (max-width: 992px) {
  h2,
  h3,
  h4,
  h5 {
    font-size: 16px;
  }
}
h4 {
  font-size: 18px;
  color: #fff;
}
@media (max-width: 992px) {
  h4 {
    font-size: 15px;
  }
}
p {
  font-size: 16px;
  line-height: 120%;
  vertical-align: middle;
  color: #fff;
}
@media (max-width: 992px) {
  p {
    font-size: 14px;
  }
}
/*# sourceMappingURL=impressum.page.css.map */
